import { buildRouteHead } from "@/lib/seo/routeHead";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/jonathan-boel")({
  head: () => buildRouteHead("/jonathan-boel", { noIndex: true }),
  beforeLoad: () => {
    throw redirect({ to: "/en/about-qbd/team", replace: true });
  },
});
